import { useTranslation } from 'react-i18next'
import { ANIMAL_TYPES, type AnimalType } from '../lib/constants'

interface Props {
  idPrefix: string
  value: AnimalType | ''
  onChange: (value: AnimalType) => void
  showRequiredError?: boolean
}

export function AnimalTypePicker({
  idPrefix,
  value,
  onChange,
  showRequiredError = false,
}: Props) {
  const { t } = useTranslation()

  return (
    <fieldset className={`report-section${showRequiredError ? ' has-error' : ''}`}>
      <legend>{t('fields.type')}</legend>
      <div className="choice-triple" role="radiogroup" aria-labelledby={`${idPrefix}-type-legend`}>
        <span id={`${idPrefix}-type-legend`} className="visually-hidden">
          {t('fields.type')}
        </span>
        {ANIMAL_TYPES.map((key) => (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={value === key}
            className={`choice-button${value === key ? ' selected' : ''}`}
            onClick={() => onChange(key)}
          >
            {value === key && <span aria-hidden="true">✓</span>}
            {t(`types.${key}`)}
          </button>
        ))}
      </div>
      {showRequiredError && (
        <p className="field-error" role="alert">
          {t('fields.selectOne')}
        </p>
      )}
    </fieldset>
  )
}
